import { scoreBadge } from '../lib/scoring';

export function ScoreBadge({ score }: { score: number }) {
  const variant = scoreBadge(score);
  return <span className={`badge ${variant}`}>{score} / 100</span>;
}
